import { render, staticRenderFns } from "./Asia.vue?vue&type=template&id=6f6b3fca&scoped=true&"
import script from "./Asia.vue?vue&type=script&lang=js&"
export * from "./Asia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f6b3fca",
  null
  
)

export default component.exports